export type DeviceInfo = {
  hostname: string;
  os_name: string;
  os_arch: string;
};

export async function resolveDeviceInfo(): Promise<DeviceInfo> {
  const fromElectron = await window.electron?.getDeviceInfo?.();
  if (fromElectron?.hostname) return fromElectron;
  const platform = typeof navigator !== 'undefined' ? navigator.platform : '';
  return {
    hostname: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 80) : 'unknown',
    os_name: platform.slice(0, 64) || 'unknown',
    os_arch: platform.includes('64') ? 'x64' : 'unknown',
  };
}
